import { classNames } from 'shared/lib/classNames/classNames';
import { useSelector } from 'react-redux';
import { getPlotStepData } from 'widgets/PlotSteps';
import { DynamicAnswer } from 'features/StepActions/ui/DynamicAnswer';
import { BlockSelection } from './BlockSelection';
import { WorkSchedule } from './WorkSchedule';
import { MoneyView } from './MoneyView';
import { ButtonsView } from './ButtonsView';
import { QuestionView } from './QuestionView';
import { FinalSum } from './FinalSum';
import { FinalScreen } from './FinalScreen';
import { SmsView } from './SmsView';
import cls from './StepActions.module.scss';
import { LevelLoading } from './LevelLoading';

interface StepActionsProps {
    className?: string
}
export const StepActions = (props: StepActionsProps) => {
    const {
        className,
    } = props;
    const stepData = useSelector(getPlotStepData);
    const mods = {
        [cls.buttonsView]: stepData?.action?.buttonsView,
        [cls.questionView]: stepData?.action?.questionView,
        [cls.blockSelection]: stepData?.action?.blockSelection,
    };

    return (
        <div className={classNames(cls.StepActions, mods, [className])}>
            {stepData?.action?.effectOfGrowing
                && (
                    <LevelLoading characters={stepData?.speakerImgs} backgroundKeys={stepData?.backgrounds} stepNumber={stepData?.action?.stepNumber} />
                )}
            {stepData?.action?.buttonsView
                && (
                    <ButtonsView />
                )}
            {stepData?.action?.moneyView
                && (
                    <MoneyView />
                )}
            {stepData?.action?.questionView
                && (
                    <QuestionView />
                )}
            {stepData?.action?.blockSelection
                && (
                    <BlockSelection />
                )}
            {stepData?.action?.workSchedule
                && (
                    <WorkSchedule />
                )}
            {stepData?.action?.smsView
                && (
                    <SmsView />
                )}
            {stepData?.action?.dynamicAnswer
                && (
                    <DynamicAnswer />
                )}
            {stepData?.action?.finalSum
                && (
                    <FinalSum />
                )}
            {stepData?.action?.finalScreen
                && (
                    <FinalScreen />
                )}
        </div>
    );
};
